import { createTypes } from '../../utils/helpers';

export const POS_TYPES_FETCH_POS_TYPES: any = createTypes(
  'POS_TYPES_FETCH_POS_TYPES',
);
